import { render, staticRenderFns } from "./BrandsSidebar.vue?vue&type=template&id=c65c5612"
import script from "./BrandsSidebar.vue?vue&type=script&lang=js"
export * from "./BrandsSidebar.vue?vue&type=script&lang=js"
import style0 from "./BrandsSidebar.vue?vue&type=style&index=0&id=c65c5612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports